module.exports = __webpack_public_path__ + "c05ff2e6d948f59873c2094fa5b304d9.jpg";